import { combineReducers } from 'redux';
import appReducer from './appReducer';
import { rsMessageModuleStore } from './messageModuleReducer/index';


export default combineReducers({
  rsMessageModuleStore,
  app: appReducer
});
